import React, { useEffect, useState } from "react";

export default function Header({ user, onLogout }) {
  const [time, setTime] = useState(new Date());

  // ⏱ Live clock
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (!user) return null;

  return (
    <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-primary text-white">
      {/* LEFT */}
      <div>
        <b>Welcome to SMB Group</b>
      </div>

      {/* CENTER */}
      <div>
        Login: {user.name} ({user.role})
      </div>

      {/* RIGHT */}
      <div className="d-flex align-items-center gap-3">
        <span>
          {time.toLocaleDateString()} {time.toLocaleTimeString()}
        </span>

        {/* 🔴 LOGOUT BUTTON */}
        <button
          className="btn btn-sm btn-light"
          onClick={() => {
            console.log("Logout clicked");
            onLogout();
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
}